import { loadStripe } from '@stripe/stripe-js'
import donateCommonMixin from '@/mixins/donations/donateCommonMixin.js'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'
import teamPublicFetchMixin from '@/mixins/teamPublicFetchMixin.js'
import { useTeamPublicStore } from '@/stores/teamPublic.js'

export default {
  mixins: [ donateCommonMixin, teamPublicFetchMixin],
  computed: {
    returnPageRoute() {
      return { name: 'TeamDonationReturnPublicPage', params: { teamId: this.team.id, donationId: this.Donation.id } }
    },
    fundraiser() {
      return useFundraiserPublicStore().getItemById(this.team.fundraiser_id)
    }
  },
  async beforeMount() {
    const team = await this.fetchTeamPublic()
    await useFundraiserPublicStore().fetchItemById(team.fundraiser_id)
  },
  async beforeUnmount() {
    await this.cancelDonation()
  },
  methods: {
    async fetchClientSecret() {
      try {
        this.ValidationErrorMessage = null
        this.Loading = true
        const response = await useTeamPublicStore().startDonation({
          team_id: this.team.id,
          app_fee: this.DonationAppFeeAmount,
          amount: this.DonationAmount,
          anonymous_name: this.DonationAnonymousName,
          anonymous_amount: this.DonationAnonymousAmount,
          comment: this.DonationComment
        })
        this.Donation = response.donation
        return response.payment_service.client_secret
      } catch (e) {
        console.error(e)
        this.Loading = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async startDonation() {
      if(this.StripeCheckoutObject) {
        await this.StripeCheckoutObject.destroy()
        this.DonationGatewayActive = false
      }
      const stripe = await loadStripe(import.meta.env.VITE_APP_STRIPE_PUBLISHABLE_KEY, {
        stripeAccount: this.fundraiser.cached.payment_service_account_id,
      })
      this.DonationGatewayActive = true
      this.StripeCheckoutObject = await stripe.initEmbeddedCheckout({
        fetchClientSecret: this.fetchClientSecret,
        onComplete: async (complete) => {
          await this.StripeCheckoutObject.destroy()
          this.DonationGatewayActive = false
          this.DonationCompleted = true
          this.DonationAmount = null
          this.DonationAnonymousName = false
          this.DonationAnonymousAmount = false
          this.DonationShowCommentForm = false
          this.DonationComment = null
          this.StripeCheckoutObject = null
          this.$notify('Donation completed successfully!')
          console.log('complete:', complete)
          if(this.Donation) {
            this.$router.push(this.returnPageRoute)
          }
        }
      });
      // Mount Checkout
      this.StripeCheckoutObject.mount('#checkout');
    },
    async cancelDonation() {
      await this.StripeCheckoutObject.destroy()
      this.DonationGatewayActive = false
    }
  }
}
